import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { getFlexibleCancellationDays, isFlexibleCancellationPolicy, isWithinSevenDays } from 'lib/cancellationPolicy'
import OfferPropertyCancellationPolicies from 'components/Common/CancellationPolicies/Flash/OfferPropertyCancellationPolicies'
import OfferPropertyFlexibleCancellationPolicies from 'components/Common/CancellationPolicies/Flash/OfferPropertyFlexibleCancellationPolicies'
import { isChangePackage } from 'selectors/cart/cartSelectors'
import Group from 'components/utils/Group'

interface Props {
  offerId?: string;
  uniqueKey?: string;
  propertyTimezoneOffset?: number;
  cancellationPolicy?: App.OfferCancellationPolicy;
  checkInDate?: string | moment.Moment;
  isChangePackage: boolean;
  isFlashUSP?: boolean;
  startIcon?: React.ReactNode;
}

export const showFreeCancellation = (
  checkInDate: string | moment.Moment | undefined,
  isChangePackage: boolean,
  cancellationPolicy: App.OfferCancellationPolicy | undefined,
) => {
  if (isChangePackage || !cancellationPolicy) {
    return false
  }
  if (cancellationPolicy?.type !== 'post-purchase-seven-days') {
    return false
  }
  if (!checkInDate) {
    return true
  } else {
    return moment(checkInDate).subtract(21, 'days').isAfter(moment().startOf('day'))
  }
}

export const showFlexibleCancellation = (
  checkInDate: string | moment.Moment | undefined,
  isChangePackage: boolean,
  cancellationPolicy: App.OfferCancellationPolicy | undefined,
) => {
  if (isChangePackage || !cancellationPolicy) {
    return false
  }
  if (!isFlexibleCancellationPolicy(cancellationPolicy)) {
    return false
  }
  if (!checkInDate) {
    return true
  } else {
    const days = getFlexibleCancellationDays(cancellationPolicy)
    const isWithinChangeOfMind = isWithinSevenDays(moment(), moment(checkInDate), moment())
    return isWithinChangeOfMind || moment(checkInDate).subtract(days, 'days').isAfter(moment().startOf('day'))
  }
}

function FlashCancellationPolicies({
  cancellationPolicy,
  checkInDate,
  propertyTimezoneOffset,
  isChangePackage,
  isFlashUSP,
  startIcon,
}: Props) {
  const freeCancellation = showFreeCancellation(checkInDate, isChangePackage, cancellationPolicy)
  const flexibleCancellation = showFlexibleCancellation(checkInDate, isChangePackage, cancellationPolicy)

  if (!freeCancellation && !flexibleCancellation) {
    return null
  }

  return (
    <Group direction="horizontal" gap={4} horizontalAlign="start" smVerticalAlign="center">
      {startIcon}
      <>
        {freeCancellation && <OfferPropertyCancellationPolicies
          propertyTimezoneOffset={propertyTimezoneOffset}
          checkInDate={checkInDate}
          isFlashUSP={isFlashUSP}
        />}
        {flexibleCancellation && <OfferPropertyFlexibleCancellationPolicies
          cancellationPolicy={cancellationPolicy!}
          propertyTimezoneOffset={propertyTimezoneOffset}
          checkInDate={checkInDate}
          isFlashUSP={isFlashUSP}
        />}
      </>
    </Group>

  )
}

function mapStateToProps(state: App.State, ownProps: Partial<Props>) {
  const offer = state.offer.offers[ownProps.offerId as string]
  const pkg = offer?.packages.find(pkg => pkg.uniqueKey === ownProps.uniqueKey)

  return {
    isChangePackage: isChangePackage(state),
    cancellationPolicy: ownProps.cancellationPolicy || pkg?.roomRate?.cancellationPolicy,
  }
}

export default connect(mapStateToProps)(FlashCancellationPolicies)
